import { useTranslation } from 'react-i18next';
import { CardNetworkWidget } from '@/common/components/CardNetworkWidget/CardNetworkWidget';
import { PLAN } from '@/common/constants/markets';
import { ROUTES } from '@/common/constants/routes';
import { useMarket } from '@/common/hooks/useMarket';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { useAvailableBenefitCategories } from '@/web/hooks/benefits';
import { useLocalSearchParams } from 'expo-router';
import { ITFringeCardPocket } from './ITFringeCardPocket/ITFringeCardPocket';
import { ITMealVoucherCardPocket } from './ITMealVoucherCardPocket/ITMealVoucherCardPocket';
import { ITSinglePaymentCard } from './ITSinglePaymentCard/ITSinglePaymentCard';
import { ITSinglePaymentModal } from './ITSinglePaymentModal/ITSinglePaymentModal';
import { ITSinglePaymentOnboardingModal } from './ITSinglePaymentOnboardingModal/ITSinglePaymentOnboardingModal';
import { ITWelfareCardPocket } from './ITWelfareCardPocket/ITWelfareCardPocket';

export function useITPrimaryActions() {
  const {
    features: { ff_single_meal_launching_campaign },
  } = useFeatures();
  const { plan } = useMarket();

  switch (plan) {
    case PLAN.ITALY:
    case PLAN.ITALY_FULL:
      return ff_single_meal_launching_campaign ? <ITSinglePaymentCard /> : null;
    default:
      return null;
  }
}

export function useITPocketCards() {
  const { plan } = useMarket();

  switch (plan) {
    case PLAN.ITALY_FULL:
      return [
        <ITMealVoucherCardPocket key="meal-voucher" />,
        <ITWelfareCardPocket key="welfare" />,
      ];
    case PLAN.ITALY:
      return <ITMealVoucherCardPocket />;
    case PLAN.ITALY_FRINGE:
      return <ITFringeCardPocket />;
  }
}

export function useITSecondaryActions() {
  const { t } = useTranslation();
  const { plan } = useMarket();
  const { meal } = useAvailableBenefitCategories();

  switch (plan) {
    case PLAN.ITALY:
    case PLAN.ITALY_FULL:
      return (
        meal && (
          <CardNetworkWidget
            title={t('dashboard.network_card.explore')}
            description={t('dashboard.network_card.title')}
            route={ROUTES.MEAL_NETWORK}
          />
        )
      );
    case PLAN.ITALY_FRINGE:
      return (
        <CardNetworkWidget
          title={t('dashboard.home.it.fringe_network_card.title')}
          description={t('dashboard.home.it.fringe_network_card.description')}
          route={{
            pathname: ROUTES.WELFARE_CATEGORIES,
            params: { slug: 'fringe' },
          }}
        />
      );
  }
}

export function useITHomePageModal() {
  const {
    features: { ff_single_meal_launching_campaign },
  } = useFeatures();
  const { plan } = useMarket();
  const queryParams = useLocalSearchParams<{
    origin: string;
  }>();

  switch (plan) {
    case PLAN.ITALY:
    case PLAN.ITALY_FULL:
      if (ff_single_meal_launching_campaign) {
        return queryParams.origin === 'onboarding' ? (
          <ITSinglePaymentOnboardingModal />
        ) : (
          <ITSinglePaymentModal />
        );
      }
    default:
      return null;
  }
}
